module.exports = __webpack_public_path__ + "img/speaking_EN.fc7ea27a.png";